var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhoneSvg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 21,
    viewBox: "0 0 19 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.8475 13.6793L14.4569 15.9247C14.4204 16.1217 14.3243 16.2737 14.1687 16.3807C14.013 16.4877 13.8367 16.5229 13.6397 16.4864C12.127 16.2655 10.755 15.7545 9.52386 14.9533C8.2927 14.1522 7.28258 13.1776 6.49349 12.0295C5.70439 10.8815 5.15806 9.59172 4.8545 8.16011C4.55094 6.72851 4.5637 5.26212 4.89278 3.76096C4.92928 3.56397 5.02536 3.41197 5.18103 3.30498C5.33669 3.19798 5.51302 3.16273 5.71001 3.19923L7.94626 3.63905C8.12683 3.67251 8.27047 3.75643 8.37716 3.89081C8.48386 4.02519 8.53355 4.18085 8.52623 4.35778L8.40559 6.93333C8.40072 7.05129 8.37274 7.15647 8.32166 7.24888C8.27057 7.3413 8.19639 7.42094 8.0991 7.48781L6.43545 8.63133C6.57282 9.08127 6.7412 9.52423 6.94058 9.9602C7.13997 10.3962 7.38009 10.8185 7.66096 11.2271C7.94182 11.6357 8.25005 12.0112 8.58564 12.3535C8.92123 12.6959 9.27446 13.0118 9.64532 13.3012L11.309 12.1577C11.4063 12.0908 11.5072 12.0501 11.6118 12.0355C11.7164 12.0209 11.8246 12.0325 11.9365 12.0702L14.3842 12.8803C14.5521 12.9369 14.6796 13.039 14.7668 13.1868C14.854 13.3346 14.8809 13.4987 14.8475 13.6793Z",
    fill: "#535969"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoneSvg);
export default __webpack_public_path__ + "static/media/phoneSvg.0d4187d63a388b7ef497e760c73a1a4e.svg";
export { ForwardRef as ReactComponent };